export const createGetTeamRoleRequest = () => {
  return {
    url: "/teams/roles",
    method: "GET",
  };
};

export const createGetWorkSpaceMembersRequest = () => {
  return {
    url: "/teams/workspace_members",
    method: "GET",
  };
};

export const createGetPendingInvitationsRequest = () => {
  return {
    url: "/teams/pending_invitations",
    method: "GET",
  };
};

export const createCancelInviteRequest = (inviteId) => {
  return {
    url: "/teams/invitations/" + inviteId,
    method: "DELETE",
  };
};

export const createInviteMemberRequest = (email, role_id, redirect_to, existing_user_redirect_to) => {
  return {
    url: "/teams/invite_member_direct",
    method: "POST",
    data: {
      email,
      role_id,
      redirect_to,
      existing_user_redirect_to,
    },
  };
};

export const createRemoveMemberRequest = (user_id) => {
  return {
    url: "/teams/remove_member",
    method: "POST",
    data: {
      user_id,
    },
  };
};

export const createGetInvitationDetails = () => {
  return {
    url: "/teams/user_invitation",
    method: "GET",
  };
};

export const createAcceptInvitationRequest = (id) => {
  return {
    url: "/teams/accept_invitation",
    method: "POST",
    data: {
      id,
    },
  };
};

export const createAcceptAllInvitationsRequest = () => {
  return {
    url: "/teams/accept_all_invitations",
    method: "POST",
  };
};

export const createInviteOrgAdminRequest = (email, redirect_url) => {
  return {
    url: "/teams/invite_org_admin",
    method: "POST",
    data: { email, redirect_url },
  };
};

export const createGetOrgAdminsRequest = () => {
  return {
    url: "/teams/org_admins",
    method: "GET",
  };
};

export const createRemoveOrgAdminRequest = (user_id) => {
  return {
    url: "/teams/remove_org_admin",
    method: "POST",
    data: { user_id },
  };
};
